import React, { useState, useEffect } from "react";
import "../style/debtPayOff.css";
import NewLoader from "../../../styled-components/loader/NewLoader";
import moment from "moment";

export const TransactionList = (props) => {
  const [loading, setLoading] = useState(false);
  return (
    <div style={{ position: "relative" }}>
      {" "}
      <div className="cardHeadingDebt">Payment Tracker</div>
      <div className="listingContainer">
        <React.Fragment>
          {props.data && props.data.length > 0 ? (
            props.data.map((item, index) => {
              const module = props && props.modules && props.modules.find(module => module.id === item.itemId);
              let totalAmountPaid=0;
              if (module) {
              const relevantTransactions = props && props.data && props.data.filter(transaction => transaction.itemId ===  module.id);
              totalAmountPaid = relevantTransactions && relevantTransactions.reduce((accumulator, transaction) => {
                return accumulator + transaction.amount;
              }, 0);
            }
              return (
                <div key={index} className="list-row-noBg">
                  <div className="listname-dark">
                    <div>
                      {" "}
                      {item.created_at &&
                        moment(item.created_at).format("MMMM Do, YYYY")}
                    </div>
                  </div>
                  <div className="listname-dark">
                    <div>
                      {" "}
                      {item.module && module && module["Nickname of Liabilities"] && module["Nickname of Liabilities"]}
                    </div>
                    <div style={{ color: "black", fontWeight: "400" }}>
                      $
                      {module && module["Initial Loan Amount"] &&
                      (module["Initial Loan Amount"]-totalAmountPaid)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </div>
                  </div>
                  <div className="listname-dark">
                    <div style={{ color: "#26C0E2", fontWeight: "400" }}>
                      $
                      {item.amount &&
                        item.amount
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </div>
                    <div
                      // className="listStatus"
                      style={{
                        color:
                          item.status && item.status === "Extra"
                            ? "green"
                            : "#6c757d",
                        fontWeight: "600",
                      }}
                    >
                      {item.status ? item.status : "N/A"}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="nodata">No data to show</div>
          )}
        </React.Fragment>
      </div>
      <NewLoader isLoading={props.loading} />
    </div>
  );
};
